function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  width: 231,
  height: 1024
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -1.4,
  width: 118.6,
  height: 104.2,
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox",
  id: "filter-4"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "path-5",
  width: 231,
  height: 1790
}), /*#__PURE__*/React.createElement("filter", {
  x: -9.3,
  y: -0.8,
  width: 118.6,
  height: 102.4,
  filterUnits: "objectBoundingBox",
  id: "filter-6"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.258576766   0 0 0 0 0.255985086   0 0 0 0 0.255985086  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 7,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411514946   0 0 0 0 0.411514946   0 0 0 0 0.411514946  0 0 0 0.03 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  id: "FAB-1",
  transform: "translate(-32 -164)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1645,
  height: 1024,
  fill: "#FBFBFB"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-18"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-2)",
  xlinkHref: "#path-1",
  fill: "black"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Fill-365-+-Fill-366"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.9 180.7L47 180.7 44.9 178.6 47 176.5 53.9 176.5 53.9 180.7ZM48.1 168.4L49.1 170.2 43.6 170.2 48.1 168.4ZM55 174.4L53.9 174.4 53.9 172.3C53.9 171.1 53 170.2 51.8 170.2L51.4 170.2 49.6 166.6C49.3 166.1 48.8 165.9 48.3 166.1L37.9 170.2 37.1 170.2C35.9 170.2 35 171.1 35 172.3L35 184.9C35 186.1 35.9 187 37.1 187L51.8 187C53 187 53.9 186.1 53.9 184.9L53.9 182.8 55 182.8C55.5 182.8 56 182.3 56 181.7L56 175.4C56 174.9 55.5 174.4 55 174.4L55 174.4Z",
  id: "Fill-365",
  fill: "#38BAAC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.7 179.6C48.3 179.6 48.7 179.2 48.7 178.6 48.7 178 48.3 177.5 47.7 177.5 47.1 177.5 46.6 178 46.6 178.6 46.6 179.2 47.1 179.6 47.7 179.6",
  id: "Fill-366",
  fill: "#FFF"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-30"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-18"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-4)",
  xlinkHref: "#path-3",
  fill: "black"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Fill-365-+-Fill-366"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.9 180.7L47 180.7 44.9 178.6 47 176.5 53.9 176.5 53.9 180.7ZM48.1 168.4L49.1 170.2 43.6 170.2 48.1 168.4ZM55 174.4L53.9 174.4 53.9 172.3C53.9 171.1 53 170.2 51.8 170.2L51.4 170.2 49.6 166.6C49.3 166.1 48.8 165.9 48.3 166.1L37.9 170.2 37.1 170.2C35.9 170.2 35 171.1 35 172.3L35 184.9C35 186.1 35.9 187 37.1 187L51.8 187C53 187 53.9 186.1 53.9 184.9L53.9 182.8 55 182.8C55.5 182.8 56 182.3 56 181.7L56 175.4C56 174.9 55.5 174.4 55 174.4L55 174.4Z",
  id: "Fill-365",
  fill: "#38BAAC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.7 179.6C48.3 179.6 48.7 179.2 48.7 178.6 48.7 178 48.3 177.5 47.7 177.5 47.1 177.5 46.6 178 46.6 178.6 46.6 179.2 47.1 179.6 47.7 179.6",
  id: "Fill-366",
  fill: "#FFF"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-6)",
  xlinkHref: "#path-5",
  fill: "black"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Nav/My_Center/On"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 32,
  y: 164,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "moje_konto2_on",
  fill: "#48A9A1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.4 175.1L48.7 167.1C48.6 167 48.4 166.9 48.2 166.9L40.3 166.9C40.1 166.9 39.9 167 39.8 167.1L34.1 175.1C33.9 175.3 33.9 175.5 34.1 175.7 34.2 175.9 34.4 176.1 34.6 176.1L36.5 176.1 36.5 185C36.5 185.3 36.8 185.6 37.1 185.6L51.4 185.6C51.7 185.6 51.9 185.3 52 185L52 176.1 53.9 176.1C54.1 176.1 54.3 175.9 54.5 175.7 54.6 175.5 54.5 175.3 54.4 175.1L54.4 175.1ZM50.8 184.4L46.5 184.4 46.5 179.1C46.5 178.8 46.2 178.5 45.9 178.5L42.6 178.5C42.3 178.5 42 178.8 42 179.1L42 184.4 37.7 184.4 37.7 176 50.8 176 50.8 184.4ZM35.8 174.8L40.6 168.1 47.9 168.1 52.7 174.9 35.8 174.8Z",
  id: "Shape"
}))))));

var SvgCentrumSider = function SvgCentrumSider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCentrumSider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CentrumSider.d0767370.svg";
export { ForwardRef as ReactComponent };